import { render, staticRenderFns } from "./FeaturedCategories.vue?vue&type=template&id=822bf998&scoped=true"
import script from "./FeaturedCategories.vue?vue&type=script&lang=js"
export * from "./FeaturedCategories.vue?vue&type=script&lang=js"
import style0 from "./FeaturedCategories.vue?vue&type=style&index=0&id=822bf998&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "822bf998",
  null
  
)

export default component.exports